module.exports = {
          srcSet: __webpack_public_path__ + "68cc1732f791e679357d155c6a4f68e1-77.png"+" 77w",
          images:[ {path: __webpack_public_path__ + "68cc1732f791e679357d155c6a4f68e1-77.png",width: 77,height: 78}],
          src: __webpack_public_path__ + "68cc1732f791e679357d155c6a4f68e1-77.png",
          toString:function(){return __webpack_public_path__ + "68cc1732f791e679357d155c6a4f68e1-77.png"},
          
          width: 77,
          height: 78
        }